module.exports = __webpack_public_path__ + "img/5.3a0916a5.png";